define('OutSystems/ClientRuntime/WidgetNaming',["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.WidgetIdService = exports.NamespaceKind = void 0;
    var NamespaceKind;
    (function (NamespaceKind) {
        NamespaceKind[NamespaceKind["Block"] = 0] = "Block";
        NamespaceKind[NamespaceKind["IteratorItem"] = 1] = "IteratorItem";
        NamespaceKind[NamespaceKind["None"] = 2] = "None";
    })(NamespaceKind = exports.NamespaceKind || (exports.NamespaceKind = {}));
    var WIDGET_ID_SEPARATOR = "-";
    var WidgetIdService = (function () {
        function WidgetIdService(_ownerService, ownerAlias, namespaceKind, index) {
            if (ownerAlias === void 0) { ownerAlias = ""; }
            if (namespaceKind === void 0) { namespaceKind = NamespaceKind.None; }
            if (index === void 0) { index = null; }
            this._ownerService = _ownerService;
            switch (namespaceKind) {
                case NamespaceKind.Block:
                    this._namespace = "b";
                    break;
                case NamespaceKind.IteratorItem:
                    this._namespace = "l";
                    break;
                default:
                    this._namespace = "";
                    break;
            }
            this._namespace += ownerAlias;
            if (_ownerService) {
                var indexPart = index ? index + WIDGET_ID_SEPARATOR : "";
                this._namespace = _ownerService.namespace + this._namespace + WIDGET_ID_SEPARATOR + indexPart;
            }
            else if (this._namespace) {
                this._namespace = this._namespace + WIDGET_ID_SEPARATOR;
            }
        }
        WidgetIdService.prototype.getId = function (widgetName) {
            if (widgetName) {
                return this.namespace + widgetName;
            }
            return null;
        };
        WidgetIdService.nameFromId = function (id) {
            return id.substring(id.lastIndexOf(WIDGET_ID_SEPARATOR) + 1);
        };
        Object.defineProperty(WidgetIdService.prototype, "namespace", {
            get: function () {
                return this._namespace;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(WidgetIdService.prototype, "ownerService", {
            get: function () {
                return this._ownerService;
            },
            enumerable: false,
            configurable: true
        });
        return WidgetIdService;
    }());
    exports.WidgetIdService = WidgetIdService;
});
//# sourceMappingURL=WidgetNaming.js.map;
